export const useStyles = (theme) => ({
  root: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  body: {
    padding: 10,
  },
  paper: {
    padding: 10,
    borderRadius: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  inputRoot: {
    height: 40,
  },
  tableFormWidth: {
    width: 150,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
});
